/**
 * @author Красильников Даниил <dkrasilnikov@gmail.com>
 * @link https://t.me/krasilneg
 * 
 * @author Колесник Данил <90.kalias.3@gmail.com>
 * @link https://t.me/kalias_90
 */

import React, { ComponentType, useEffect, useState, PropsWithChildren, forwardRef, RefObject, useRef } from 'react';
import IntersectionListener from './IntersectionListener.class';
import IntersectionContext from './IntersectionContext';

type IntersectedProps = {
  threshold?: number;
}

export default function <T>(Component: ComponentType<T> | string) {
  return forwardRef<HTMLElement, T & IntersectedProps & PropsWithChildren>(({ children, threshold, ...props }, ref: RefObject<HTMLElement>) => {
    const [listener, setListener] = useState<IntersectionListener | null>(null);
    const mainRef = useRef<HTMLElement>(null);
    useEffect(() => {
      if (mainRef.current) {
        const l = new IntersectionListener({ root: mainRef.current, threshold });
        setListener(l);
        if (ref) {
          ref.current = mainRef.current;
        }
        return () => {
          l.disconnect();
        }
      }
    }, [mainRef, ref]);

    // const ic = useContext(intersectionContext);
    return (
      <Component ref={mainRef} {...props as T}>
        <IntersectionContext.Provider value={listener}>
          {children}
        </IntersectionContext.Provider>
      </Component>
    );
  });
};